/**
 * Sort order options for list sorting
 */
export type SortOrder = 'asc' | 'desc';

/**
 * Sort order constants
 */
export const SortOrders = {
  ASC: 'asc' as SortOrder,
  DESC: 'desc' as SortOrder,
};
